<script>
    import { HorizontalBar, mixins } from 'vue-chartjs';
    const { reactiveProp } = mixins;

    export default ({
        extends: HorizontalBar,
        mixins: [reactiveProp],
        data () {
            return {
                options: { //Chart.js options
                    scales: {
                        yAxes: [{
                            // ticks: {
                            //     beginAtZero: true,
                            //     suggestedMax: 100
                            // },
                            gridLines: {
                                display: true
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                //suggestedMax: 100
                            },
                            gridLines: {
                                display: true
                            }
                        }]
                    },
                    legend: {
                        display: true
                    },
                    tooltips: {
                        enabled: true,
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        mounted () {
            this.renderChart(this.chartData, this.options);
        }

    })
</script>

<style scoped>

</style>